import { Injectable } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';

import { AngularFireAuth} from '@angular/fire/auth';
import { AngularFirestore } from '@angular/fire/firestore';
import { environment } from "../../environments/environment";

import { ToastrService } from 'ngx-toastr';
import { EncryptionService } from './encryption.service';

import { DateTime } from "luxon";

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  env = environment;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public http: HttpClient,
    public afAuth: AngularFireAuth,
    public db: AngularFirestore,
    public toastr: ToastrService,
    public encryption_service: EncryptionService
  ) { }

  public subject = new Subject<any>();
  public sendMessage(command: string,message: string) {
    this.subject.next({
        command : command,
        text: message 
    });
  }
  
  public getMessage(): Observable<any> {
    return this.subject.asObservable();
  }

  public goto(page){
    try {
      this.router.navigate([page], { relativeTo: this.route });
    } catch (error) {
    }
  }

  public saveProfile(db){
    this.encryption_service.set_secure_item('profile', db);
  }

  public getProfile(){
    return this.encryption_service.get_secure_item('profile');
  }

  public saveProject(db){
    this.encryption_service.set_secure_item('project', db);
  }

  public getProject(){
    return this.encryption_service.get_secure_item('project');
  }

  public saveRoom(db){
    this.encryption_service.set_secure_item('rooms', db);
  }

  public getRoom(){
    return this.encryption_service.get_secure_item('rooms');
  }

  public saveMember(db){
    this.encryption_service.set_secure_item('members', db);
  }

  public getMember(){
    return this.encryption_service.get_secure_item('members');
  }

  public save_station(db){
    this.encryption_service.set_secure_item('stations', db);
  }

  public get_station(){
    return this.encryption_service.get_secure_item('stations');
  }

  // Secure logout method
  public secure_logout(){
    this.encryption_service.clear_all_secure_items();
    this.afAuth.auth.signOut();
    this.router.navigate(['/login']);
  }


  

  checkinput(text,command,number){
    if(command == '==' && text){
      if(text.length == number){
        return true;
      } else {
        return false;
      }
    } else if(command == '>' && text){
      if(text.length > number){
        return true;
      } else {
        return false;
      }
    } else if(command == '<' && text){
      if(text.length < number){
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  showTimeFormat(time){
    var show =  DateTime.fromSeconds(time/1000).toFormat('dd/LL/yy HH:mm:ss');
    return show;
  }

  showOnlyDateFormat(time){
    var show =  DateTime.fromSeconds(time/1000).toFormat('dd/LL/yy');
    return show;
  }

  showOnlyTimeFormat(time){
    var show =  DateTime.fromSeconds(time/1000).toFormat('HH:mm:ss');
    return show;
  }

  calTimeStartEnd(start,end){
    var s =  DateTime.fromSeconds(start/1000);
    var e =  DateTime.fromSeconds(end/1000);

    
    const diff = e.diff(s, ["days", "hours","minutes","seconds"]);
    var h;
    var m;
    if(diff.toObject().hours < 10){
      h = "0" + diff.toObject().hours
    } else {
      h = diff.toObject().hours
    }
    if(diff.toObject().minutes < 10){
      m = "0" + diff.toObject().minutes
    } else {
      m = diff.toObject().minutes
    }

    return h + " Hr " +  m + " m";
  }

  // http get data
  getHtpp(url){
    return new Promise((resolve, reject)=> this.http.get(this.env.url+url).subscribe((data)=>{
      resolve(data);
    }));
  }

  postHtpp(url,body){
    const options = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json'
      })
    };
    return new Promise((resolve, reject)=> this.http.post(this.env.url+url, body, options).subscribe((req)=>{
      resolve(req);
    }, (error) => {
      reject(error);
    }));
  }

  public removeDuplicates(originalArray, prop) {
    var newArray = [];
    var lookupObject  = {};
  
    for(var i in originalArray) {
       lookupObject[originalArray[i][prop]] = originalArray[i];
    }
  
    for(i in lookupObject) {
        newArray.push(lookupObject[i]);
    }
     return newArray;
  }

  public showAttr(data,name){
    if(data){
      for (var key in data) {
        if(key == name){
          return data[key];
        }
      }
      return '';
    }else{
      return ''
    }
  }


  public statusCodeToMainText(code){
    if(code == 0){
      return "STANDBY"
    } else if(code == 1){
      return "PLUG ON"
    } else if(code == 2){
      return "START CHARGE"
    } else if(code == 3){
      return "STOP BY EV"
    } else if(code == 4){
      return "STOP BY MEMBER"
    } else if(code == 5){
      return "STOP BY SYSTEM"
    } else if(code == 210){
      return "ERROR : ARC"
    } else if(code == 211){
      return "ERROR : LEAK"
    } else if(code == 212){
      return "ERROR : UNDER VOLTAGE"
    } else if(code == 213){
      return "ERROR : OVER VOLTAGE"
    } else if(code == 214){
      return "ERROR : OVER CURRENT"
    } else if(code == 215){
      return "ERROR : SHORT CIRCUIT"
    } else if(code == 216){
      return "ERROR : OVER TEMP"
    } else if(code == 217){
      return "ERROR : EQ"
    } else if(code > 200){
      return "ERROR : " + code
    }
     
  }

  public chageCodeToMainText(card){
    if(card.code == 1){
      return "REQUEST START CHARGE"
    } else if(card.code == 2){
      return "START CHARGE"
    } else if(card.code == 3){
      return "REQUEST STOP CHARGE"
    } else if(card.code == 4){
      return "STOP CHARGE";
    } else if(card.code == 100){
      return "BILL : POWER = " + parseFloat(card.power_total).toFixed(2) + " kWh, MONEY = " + parseFloat(card.money).toFixed(2) + " " + this.check_currentcy()+ " , STATION : " + this.check_uid_to_station_name(card.station_uid); 
    } else {
      return this.statusCodeToMainText(card.code);
    }
     
  }

  public chageCodeToText(code,data){
    var text = this.chageCodeToMainText(code) + " : "
    if(code == 1){
      text = text + "FROM " + data.from
    }

    return text;
  }

  public colorStatus(status_code){
    if(status_code == 0){
      return "blueText";
    } else if(status_code == 1){
      return "blueText";
    } else if(status_code == 2){
      return "greenText";
    } else if(status_code > 200){
      return "redText";
    }
  }

  public getDataMemberFromCard(card_uid){
    var member = this.getMember();
    var name = '';
    for(var i = 0; i < member.length;i++){
      if(member[i].card_uid){
        for(var j = 0;j < member[i].card_uid.length;j++){
          if(member[i].card_uid[j] == card_uid){
            return member[i].name;
          }
        }
      }
    }
    return 'SYSTEM'
  }

  public getDataMemberFromUID(uid){
    var member = this.getMember();
    for(var i = 0; i < member.length;i++){
      if(member[i].uid == uid){
       return member[i];
      }
    }
  }

  public saveDataMemberFromUID(uid,data){
    var member = this.getMember();
    for(var i = 0; i < member.length;i++){
      if(member[i].uid == uid){
        member[i] = data;
      }
    }
    this.saveMember(member);
  }

 

  sortBy(data,name) {
    var d = data.slice(0);
    d.sort((a,b)=> {
      return a[name] - b[name];
    })   
    return d.reverse();   
  }

  sortByName(data) {
    if(data){
      const res = data.sort((e1, e2) =>
          e1.name.toLowerCase().localeCompare(e2.name.toLowerCase())
      );
      return res;
    } else {
      return data;
    }
  }

  sortByRoomName(data) {
    if(data){
      const res = data.sort((e1, e2) =>
          e1.room_name.toLowerCase().localeCompare(e2.room_name.toLowerCase())
      );
      return res;
    } else {
      return data;
    }
  }

  check_show_null(text,data){
    if(data){
      return text + data;
    } else {
      return "";
    }
  }

  check_uid_to_station_name(uid){
    if(uid){
      var station_database = this.get_station();
      for(var i = 0;i < station_database.length;i++){
        if(station_database[i].uid == uid){
          return station_database[i].name;
        }
      }
    }
    return "";
  }

  check_currentcy(){
    if(this.get_project_type() == 'public'){
      return 'Point'
    } else if(this.get_project_type() == 'private'){
      return 'Baht'
    } else {
      return 'Baht'
    }
  }


  get_project_type(){
    return this.getProject().project_type;
  }
  

}
